<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <v-combobox v-model="newValue" :items="llmTags" v-bind="currentProperties()" />
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { getGraphqlSchema } from '../../../graphql/index';

const emit = defineEmits(['input']);

const props = defineProps({
  value: {
    type: Array,
    default: null
  },
  field: {
    type: Object,
    default: () => null
  },
  formContent: {
    type: Object,
    default: () => null
  }
});

const newValue = ref(props.value);

const llmTags = ref([]);

const { onResult, onError } = useQuery(
  getGraphqlSchema('llmTags'),
  {},
  { enabled: true, fetchPolicy: 'cache-first' }
);

onResult(r => {
  if (r.loading) {
    return;
  }

  llmTags.value = r.data?.llmTags || [];
});

onError(err => {
  console.log('[ERROR] llmTags query ->', err);
});

const currentProperties = () => {
  const properties = {};

  // General properties
  properties.readonly = props.field.readonly;

  properties['background-color'] = 'secondary';
  properties['menu-props'] = { light: true };
  properties['item-color'] = 'info';

  properties.label = props.field.label;
  properties.hint = props.field.helpText;
  properties.multiple = props.field.multivalued;

  if (!properties.readonly) {
    properties.clearable = true;
  }

  return properties;
};

watch(() => props.value, value => {
  newValue.value = value;
});
watch(newValue, value => {
  emit('input', value);
});

</script>

<style>
.card-action.v-card.secondary {
  border: 1px solid #fff !important;
}
</style>
